"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlAdministrativeDocumentModel = void 0;
const validator_1 = require("@leavy/validator");
const AdministrativeInfo_1 = require("../domain/administrative/AdministrativeInfo");
/**
 * An administrative document
 */
class HlAdministrativeDocumentModel {
}
__decorate([
    (0, validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], HlAdministrativeDocumentModel.prototype, "fileId", void 0);
__decorate([
    (0, validator_1.IsEnum)(AdministrativeInfo_1.AdministrativeDocumentType),
    __metadata("design:type", String)
], HlAdministrativeDocumentModel.prototype, "documentType", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsString)(),
    __metadata("design:type", String)
], HlAdministrativeDocumentModel.prototype, "label", void 0);
exports.HlAdministrativeDocumentModel = HlAdministrativeDocumentModel;
//# sourceMappingURL=HlAdministrativeDocumentModel.js.map